// frontend/js/config.js
// 1. Firebase Konfiguration (OHNE 'import'!)
const firebaseConfig = {
    apiKey: "AIzaSyAVGubKK3aTIZuVl_z_5BuKhAvMHCExN_w",
    authDomain: "presenzo-2bef1.firebaseapp.com",
    projectId: "presenzo-2bef1",
    storageBucket: "presenzo-2bef1.firebasestorage.app",
    messagingSenderId: "951704969402",
    appId: "1:951704969402:web:39ca62398da50a9191e283"
};
// Firebase Initialisierung (behalten wir bei)
if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
// 1. System-Einstellungen (ZENTRALER FIX)
window.SYS_SETTINGS = {
    // Die Keys müssen exakt so heißen wie die 'value' Attribute in deinem <select>
    prices: {
        BENZIN: 1.82,
        DIESEL: 1.68,
        ELEKTRO: 0.38,
        PUBLIC: 0.15 // Falls du später Öffis hinzufügst
    },
    co2: {
        BENZIN: 0.120,
        DIESEL: 0.145,
        ELEKTRO: 0.050,
        PUBLIC: 0.040
    },
    // Wie viel CO2 ein Baum pro Jahr bindet
    treeCo2PerYear: 12.5
};
// 2. Deine restlichen Einstellungen (behalten wir bei, aber als window-Objekt für globale Sichtbarkeit)
window.DEFAULT_COLORS = {
    HO: '#3b82f6',
    VACATION: '#22c55e'
};
window.BASE_EVENT_TYPES = {
    HO: {
        label: 'Homeoffice',
        icon: 'home'
    },
    VACATION: {
        label: 'Urlaub',
        icon: 'palmtree'
    },
    GLOBAL: {
        label: 'Admin-Eintrag',
        icon: 'flag'
    }
};
window.rolePermissions = {
    admin: {
        VIEW_TREE: true,
        MANAGE_USERS: true
    },
    user: {
        VIEW_TREE: false,
        MANAGE_USERS: false
    }
};

//# sourceMappingURL=frontend.a4799b16.js.map
